import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
};

export const couriers = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_COURIERS_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_COURIERS_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_COURIERS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': null,
    }),
  })(state, action);
};

export const transportist = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_TRANSPORTIST_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TRANSPORTIST_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_TRANSPORTIST_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': null,
    }),
  })(state, action);
};

export const dealersAgencies = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_DEALERS_AGENCIES_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_DEALERS_AGENCIES_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_DEALERS_AGENCIES_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};

export const exportCouriers = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.EXPORTING_TO_EXCEL_COURIERS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.EXPORTED_TO_EXCEL_COURIERS]: (state, action) => ({
      ...state,
      'loading': false,
      'url': action.response.data,
    }),
    [ActionTypes.EXPORTED_TO_EXCEL_COURIERS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'url': '',
    }),
    [ActionTypes.CLEAN_TRANSPORTIST_EXPORT_URL]: (state, action) => ({
      ...state,
      'loading': false,
      'url': '',
    }),
  })(state, action);
};
export const exportTransportists = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.EXPORTING_TO_EXCEL_TRANSPORTISTS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.EXPORTED_TO_EXCEL_TRANSPORTISTS]: (state, action) => ({
      ...state,
      'loading': false,
      'url': action.response.data,
    }),
    [ActionTypes.EXPORTED_TO_EXCEL_TRANSPORTISTS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'url': '',
    }),
    [ActionTypes.CLEAN_TRANSPORTIST_EXPORT_URL]: (state, action) => ({
      ...state,
      'loading': false,
      'url': '',
    }),
  })(state, action);
};
